import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IDocument, IDocumentUploadResponse, DocumentTypes } from '../interfaces/document';

@Injectable({
  providedIn: 'root'
})
export class ClaimsDocumentService {
  constructor(private http: HttpClient) { }

  retrieveAll(claimsId: number): Observable<IDocument[]> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('claimsId', claimsId.toString());

    return this.http.get<IDocument[]>(`${environment.resourceUrl}api/gwc/claim/documents`, { params: httpParams });
  }

  add(document: IDocument, partId = null): Observable<IDocumentUploadResponse> {
    let formData = new FormData();
    Object.keys(document).forEach(function (key) {
      formData.append(key, document[key]);
    });
    formData.append("partId", partId);
    return this.http.post<IDocumentUploadResponse>(`${environment.resourceUrl}api/gwc/claim/document`, formData);
  }

  remove(documentId: number): Observable<Object> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('documentId', documentId.toString());

    return this.http.delete(`${environment.resourceUrl}api/gwc/claim/document`, { params: httpParams })
  }

  download(claimsId: number, documentId: number): Observable<HttpResponse<Blob>> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('claimsId', claimsId.toString());
    httpParams = httpParams.append('documentId', documentId.toString());

    return this.http.get<Blob>(`${environment.resourceUrl}api/gwc/claim/document`, {
      observe: 'response',
      responseType: 'blob' as 'json',
      params: httpParams
    });
  }
}
